class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.querySelector("summary")
    this.summary.addEventListener('click', (e) => {
      e.preventDefault()
      
      if (e.currentTarget.parentElement.hasAttribute("open")) {
        this.openMenu(this.summary)
      } else {
        this.closeMenu(this.summary) 
      }
    })

    this.summary.addEventListener('mouseenter', (e) => {
      this.summary.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      this.openMenu(this.summary)
    })

    this.summary.addEventListener('mouseleave', (e) => {
      
      if (!e.relatedTarget.classList.contains("mega-menu__content")) {
        this.summary.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        this.closeMenu(this.summary)
      }
    })

    this.summary.parentNode.querySelector('[id^="MegaMenu"]').addEventListener('mouseleave', (e) => {
      this.summary.setAttribute('aria-expanded', this.summary.closest('details').hasAttribute('open'))
      this.closeMenu(this.summary)
    })
  }

  closeMenu (summary) {
    const anim = summary.nextElementSibling.animate(
      [
        {opacity: summary.nextElementSibling.style.opacity},
        {opacity: 0}
      ],
      {
        duration: 300
      }
    )

    anim.onfinish = () => { this.close()}
  }

  openMenu (summary) {
    summary.parentNode.setAttribute("open",'')

    summary.nextElementSibling.animate(
      [
        {opacity: 0},
        {opacity: 1}
      ],
      {
        duration: 300
      }
    )
  }
  
  onFocusOut(e) {

    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        const anim = this.content.animate(
          [
            {opacity: this.content.style.opacity},
            {opacity: 0}
          ],
          {
            duration: 300
          }
        )

        anim.onfinish = () => { this.close()}
      };
    })
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
